import { useEffect, useRef, useState } from "react"
import { ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import { verifyEmail } from "../services/User_service"
import "../css/login.css"
import logo from "../image/logo.png"
import test1 from "../image/image.gif"
import img1 from "../image/AloLogo/logo2.png"
import img2 from "../image/AloLogo/logo3.png"
import img3 from "../image/AloLogo/logo4.png"
import img4 from "../image/AloLogo/logo5.png"
import img5 from "../image/AloLogo/logo7.png"
import img6 from "../image/AloLogo/logo10.png"

import img7 from "../image/AloLogo/logo15.png"
import img8 from "../image/AloLogo/logo16.png"
import img9 from "../image/AloLogo/logo18.png"
import img10 from "../image/AloLogo/logo19.png"
import img11 from "../image/AloLogo/logo20.png"
import img12 from "../image/AloLogo/logo21.png"

import img13 from "../image/AloLogo/logo22.png"
import img14 from "../image/AloLogo/logo23.png"
import img15 from "../image/AloLogo/logo24.png"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Link, useNavigate, useSearchParams } from "react-router-dom"
import { faNewspaper, faGaugeHigh } from "@fortawesome/free-solid-svg-icons"
import { toast } from "react-toastify"
import { Card, Image } from "react-bootstrap"
import { saveUserToLocalStorage } from "../services/Login_service"

type Inputs = {
  email: string
  password: string
}

const COLOR_PRIMARY = "#2A919D"
const COLOR_SECONDARY = "#5bc1d1"
const COLOR_ACCENT = "#eb8635"

const VerifyEmail = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const [isVerifying, setIsVerifying] = useState(false)
  const [message, setMessage] = useState("Chargement...")
  const [isError, setIsError] = useState(false)
  const hasVerified = useRef(false)

  useEffect(() => {
    const token = searchParams.get("token")
    if (token && !hasVerified.current) {
      setMessage("Chargement...")
      setIsError(false)
      hasVerified.current = true
      setIsVerifying(true)
      verifyEmail(token)
        .then((response) => {
          if (response.user && response.token) {
            saveUserToLocalStorage(response.user, response.token)
          }
          // Redirection automatique vers la page de login après vérification réussie
          navigate("/login")
        })
        .catch((error) => {
          toast.error("Échec de la vérification de l'email.")
          setMessage("La vérification de votre email a échoué. Veuillez réessayer ou contacter le support.")
          setIsError(true)
          setIsVerifying(false)
        })
    } else if (!hasVerified.current) {
      setMessage("Un email de confirmation vous a été envoyé. Veuillez vérifier votre boîte de réception.")
      setIsError(false)
      setIsVerifying(false)
    }
  }, [navigate, searchParams])

  // Ajout d'un style pour centrer et rendre le message plus attrayant
  const messageBoxStyle: React.CSSProperties = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "120px",
    margin: "0 auto",
    textAlign: "center",
    background: `linear-gradient(135deg, #f9fafb 60%, ${COLOR_SECONDARY}10 100%)`,
    borderRadius: "20px",
    boxShadow: "0 2px 10px 0 rgba(0,0,0,0.08)",
    padding: "32px 24px",
    color: isError ? COLOR_ACCENT : COLOR_PRIMARY,
    fontSize: "1.1em",
    fontWeight: 500,
    maxWidth: 400,
    border: isError ? `2px solid ${COLOR_ACCENT}` : `2px solid ${COLOR_PRIMARY}40`,
  }

  const actionLinksStyle: React.CSSProperties = {
    display: "flex",
    justifyContent: "center",
    gap: "1rem",
    marginTop: "18px",
  }

  return (
    <>
      <ToastContainer />
      <div className="degrade-vertical big-height">
        {/* logo */}
        <div className="row col-section d-flex flex-column-reverse flex-md-row justify-content-center align-items-center ">
          <div className="col-12 col-md-6 col-lg-6 d-flex section-txt mt-5">
            <div className="bg-section section-tab">
              <div className="img-animate">
                <img src={test1 || "/placeholder.svg"} alt="png" className="img-fluid w-75  mb-3 ImgGif" />
              </div>
              <div className="row">
                <div className="col-md-8 justify-content-center align-items-center"></div>
              </div>
              <div className="text-title mt-3 ">
                <h1 className="font-1 mt-3 title-login">Annonce Legale Officielle</h1>
                <p className="font-2 ">
                  Bénéficiez d’une publication instantanée dans toute la France, grâce à notre plateforme sécurisée en
                  ligne, disponible 24/7 et adaptée à tout type d’annonce, des plus simples aux plus complexes.
                </p>
                <div className="subtile-item mt-3 d-flex">
                  <div className="text-subtitle-icon fs-4 ">
                    <FontAwesomeIcon icon={faNewspaper} aria-hidden="true" style={{ color: COLOR_PRIMARY }} />
                  </div>
                  <div className="text ms-3">
                    <h3 className="fs-5 text-subtitle">Choix du journal</h3>
                    <p className="font-2 fonts">
                      Vous souhaitez choisir votre support de publication ? Notre outil vous offre le plus large choix
                      de journaux digitaux et papier habilités en France.
                    </p>
                  </div>
                </div>
                <div className="subtile-item mt-3 d-flex">
                  <div className="text-subtitle-icon fs-4 ">
                    <FontAwesomeIcon icon={faGaugeHigh} aria-hidden="true" style={{ color: COLOR_PRIMARY }} />
                  </div>
                  <div className="text ms-3">
                    <h3 className="fs-5 text-subtitle">Attestation immédiate</h3>
                    <p className="font-2 fonts">
                      Quelle que soit l’urgence de votre dossier, en utilisant notre solution, l’attestation de
                      publication est disponible immédiatement avec le choix sur la méthode de facturation.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-6 d-flex bg-dark-login section-txt">
            <div className="p-3">
              <Image src={logo || "/placeholder.svg"} style={{ width: "100px" }} />
            </div>

            <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
              <Card style={{ width: "70%", border: "none", background: "transparent" }}>
                <Card.Body>
                  <Card.Title
                    style={{
                      textAlign: "center",
                      fontSize: "1.6em",
                      fontWeight: 700,
                      marginBottom: 32,
                      color: "#fff",
                      letterSpacing: 0.2,
                    }}
                  >
                    Vérification de l'adresse email
                  </Card.Title>
                  <div style={messageBoxStyle}>
                    {isVerifying ? (
                      <>
                        <span style={{ fontSize: "1.1em", color: COLOR_SECONDARY }}>
                          <span
                            className="spinner-border"
                            style={{ width: "1.5rem", height: "1.5rem", color: COLOR_SECONDARY }}
                            role="status"
                          ></span>
                          <span className="ms-3">Vérification en cours...</span>
                        </span>

                      </>
                    ) : (
                      <>
                        <span style={{ fontSize: "1.15em", lineHeight: 1.6 }}>{message}</span>
                        <div style={actionLinksStyle}>
                          <Link
                            to="/login"
                            style={{
                              color: "#fff",
                              background: COLOR_PRIMARY,
                              border: `1px solid ${COLOR_PRIMARY}`,
                              borderRadius: "5px",
                              padding: "8px 24px",
                              fontWeight: 600,
                              textDecoration: "none",
                              transition: "background 0.2s",
                            }}
                          >
                            Se Connecter
                          </Link>
                          {isError && (
                            <Link
                              to="/register"
                              style={{
                                color: "#fff",
                                background: COLOR_ACCENT,
                                border: `1px solid ${COLOR_ACCENT}`,
                                borderRadius: "5px",
                                padding: "8px 24px",
                                fontWeight: 600,
                                textDecoration: "none",
                                transition: "background 0.2s",
                              }}
                            >
                              S'inscrire
                            </Link>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                </Card.Body>
              </Card>
            </div>

            {/* <div className="row"> */}
            <div className="grid text-center mt-3">
              <div>
                <img src={img1 || "/placeholder.svg"} alt="png" className="img-fluid w-75" />
              </div>
              <div>
                <img src={img2 || "/placeholder.svg"} alt="png" className="img-fluid w-75" />
              </div>
              <div>
                <img src={img3 || "/placeholder.svg"} alt="png" className="img-fluid w-75" />
              </div>
              <div>
                <img src={img4 || "/placeholder.svg"} alt="png" className="img-fluid w-75" />
              </div>
              <div>
                <img src={img5 || "/placeholder.svg"} alt="png" className="img-fluid w-75" />
              </div>
            </div>
            <div className="grid text-center">
              <div>
                <img src={img6 || "/placeholder.svg"} alt="png" className="img-fluid w-75" />
              </div>
              <div>
                <img src={img7 || "/placeholder.svg"} alt="png" className="img-fluid w-75" />
              </div>
              <div>
                <img src={img8 || "/placeholder.svg"} alt="png" className="img-fluid w-75" />
              </div>
              <div>
                <img src={img9 || "/placeholder.svg"} alt="png" className="img-fluid w-75" />
              </div>
              <div>
                <img src={img10 || "/placeholder.svg"} alt="png" className="img-fluid w-75" />
              </div>
            </div>
            <div className="grid text-center">
              <div>
                <img src={img11 || "/placeholder.svg"} alt="png" className="img-fluid w-75" />
              </div>
              <div>
                <img src={img12 || "/placeholder.svg"} alt="png" className="img-fluid w-75" />
              </div>
              <div>
                <img src={img13 || "/placeholder.svg"} alt="png" className="img-fluid w-75" />
              </div>
              <div>
                <img src={img14 || "/placeholder.svg"} alt="png" className="img-fluid w-75" />
              </div>
              <div>
                <img src={img15 || "/placeholder.svg"} alt="png" className="img-fluid w-75" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default VerifyEmail